import { render, staticRenderFns } from "./number_size.vue?vue&type=template&id=22a3f8c9"
import script from "./number_size.vue?vue&type=script&lang=js"
export * from "./number_size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports